import React from 'react'
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material'
import QRCode from 'react-qr-code'
import TicketComponent from './TicketComponent'
import dateFormat, { masks } from "dateformat";
import { PDFDownloadLink } from "@react-pdf/renderer";
import QRGenerator from "./QRGenerator";


function SuccessComponent({ data, reference }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center' }}>
            {/* <Typography variant='h5'>Votre prise de <b>RENDEZ-VOUS a été effectuée avec succès</b>.</Typography> */}
            <Typography variant='h5' style={{ color: 'white' }}>
                {/* Votre prise de <b>RENDEZ-VOUS a été effectuée avec succès</b>. */}
                Voaray Tompoko ny <b>famandrihan-toerana</b> nataonao.
            </Typography>
            <br />
            <img src={require('../assets/successImg.png')} style={{ width: '25%' }} />
            <br />
            <Typography variant='subtitle1' style={{ color: 'white' }}>
                {/* Ci-joint, veuillez trouver votre pièce justificative.<br /> Nous vous remercions de bien vouloir conserver ce ticket et de l'apporter lors de votre <b>RENDEZ-VOUS</b>. */}
                Indro ampiarahana amin’izao ny sary fanamarinana.<br /> Tehirizo tsara ny tapakila izay Mila hoentina amin'ny fotoana ifanaovana aminao.
            </Typography>
            <br />
            <Card sx={{ width: { md: '40%', sm: '40%', xs: '80%' } }}>
                <CardContent style={{ textAlign: 'center' }}>
                    {/* <Typography variant='subtitle1'><u><b>TICKET</b></u></Typography> */}
                    <Typography variant='subtitle1'><u><b>TAPAKILA</b></u></Typography>
                    <QRGenerator value={reference.toString()} documentId={reference} />
                    {/* <Typography variant='subtitle1'><b><u>Numéro de référence</u>:</b> {reference} </Typography> */}
                    <Typography variant='subtitle1'><b><u>Laharana</u>:</b> {reference} </Typography>
                </CardContent>
            </Card>
            <CardActions style={{ justifyContent: 'flex-end' }}>
                <PDFDownloadLink document={<TicketComponent data={data} />} fileName={`rdv_${dateFormat(new Date(), 'yyyymmddHHMMss')}.pdf`}>
                    <Button variant='contained' size="small"
                        sx={{
                            textTransform: "none", bgcolor: 'rgb(1,166,1)', border: '1px solide rgb(1,166,1)', ":hover": {
                                bgcolor: 'rgb(1,127,1)'
                            }
                        }}>
                        {/* Télecharger */}
                        Tehirizina
                    </Button>
                </PDFDownloadLink>
            </CardActions>
        </div>
    )
}

export default SuccessComponent